// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

var Caml_option = require("rescript/lib/js/caml_option.js");
var Form__Input = require("../../../uikit/reason/atoms/Form/Form__Input.bs.js");
var Form__Helpers = require("../../../reason/common/Form/Form__Helpers.bs.js");
var Form__Components = require("../../../reason/common/Form/Form__Components.bs.js");
var JsxRuntime = require("react/jsx-runtime");
var CssGrid = require("components/CssGrid");
var RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
var PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql = require("../../../__generated__/PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.bs.js");

var convertFragment = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Caml_option.some(Caml_option.valFromOption(fRef)) : undefined, PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.node, convertFragment, fRef);
}

var DraftFragment_localDraftPropertyType_decode = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_decode;

var DraftFragment_localDraftPropertyType_fromString = PropertyWizardRelayKeyFactsPriceExactPrice_draft_graphql.Utils.localDraftPropertyType_fromString;

var DraftFragment = {
  localDraftPropertyType_decode: DraftFragment_localDraftPropertyType_decode,
  localDraftPropertyType_fromString: DraftFragment_localDraftPropertyType_fromString,
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function PropertyWizardRelay__KeyFacts__Price__ExactPrice(props) {
  var price = props.price;
  var draft = use(props.draft);
  var match = draft.draftProperty.propertyType;
  var tmp;
  tmp = match === "FOR_SALE" ? "Price" : "Rent/month";
  return JsxRuntime.jsx(JsxRuntime.Fragment, {
              children: Caml_option.some(JsxRuntime.jsxs(CssGrid.Cell, {
                        width: 12,
                        widthMd: 4,
                        children: [
                          JsxRuntime.jsx(Form__Input.make, {
                                labelText: tmp,
                                onChange: (function ($$event) {
                                    price.onChange(Form__Helpers.intFromFormattedPrice($$event));
                                  }),
                                onBlur: (function (param) {
                                    price.onBlur();
                                  }),
                                onFocus: (function (param) {
                                    price.onFocus();
                                  }),
                                status: price.status,
                                prepend: "$",
                                value: Form__Helpers.intOptToFormattedPrice(price.value)
                              }),
                          JsxRuntime.jsx(Form__Components.FieldError.make, {
                                valid: price.valid
                              })
                        ]
                      }))
            });
}

var Components;

var FormSection;

var TextInputField;

var Cell;

var FormUtils;

var Validators;

var make = PropertyWizardRelay__KeyFacts__Price__ExactPrice;

exports.Components = Components;
exports.FormSection = FormSection;
exports.TextInputField = TextInputField;
exports.Cell = Cell;
exports.FormUtils = FormUtils;
exports.Validators = Validators;
exports.DraftFragment = DraftFragment;
exports.make = make;
/* Form__Input Not a pure module */
